// extracted by mini-css-extract-plugin
export var blackContainer = "index-module--blackContainer--PG805";
export var container = "index-module--container--mVTcS";
export var list = "index-module--list--mDQDt";
export var listItem = "index-module--listItem--aS-bJ";
export var section = "index-module--section--STNii";
export var title = "index-module--title--xgZqE";
export var videoDescription = "index-module--videoDescription--0xBQB";
export var videoPreview = "index-module--videoPreview--5tsEV";